import React, { useState } from 'react';

import scss from './DemoUsersTable.module.scss';
import CommonIconButton from '../../../../components/common-icon-button/CommonIconButton';
import { ICONS } from '../../../../icons';

function PasswordCell({ password }) {
  const [isHidden, setIsHidden] = useState(true);

  const handleToggleVisibility = () => {
    setIsHidden((prev) => !prev);
  };

  const formattedPassword = isHidden ? '*'.repeat(password.length) : password;

  return (
    <div className={scss.passwordCell}>
      {formattedPassword}
      <CommonIconButton icon={isHidden ? ICONS.EyeCrossed : ICONS.Eye} onClick={handleToggleVisibility} isStrokeIcon />
    </div>
  );
}

export default PasswordCell;
